import { useEffect } from 'react';
import { addListenerForNavigation, addListenerForQuicknotesNavigation } from '../../mobile/navigation/navigationUtils';
import { useDispatch } from 'react-redux';

export default function () {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(addListenerForNavigation());
        dispatch(addListenerForQuicknotesNavigation());
    }, [dispatch]);
}
